export default {
  submitText: '保存',
  emptyBtn: false,
  group: [
    {
      // label: '住户信息',
      // prop: 'group2',
      column: [
        {
          label: '主键',
          prop: 'id',
          display: false,
        },
        {
          label: '人员名称',
          prop: 'householdName',
          display: true,
          span: 12,
          rules: [
            {
              required: true,
              message: '请输入人员名称',
              trigger: 'blur',
            },
          ],
        },
        {
          label: '人员类型',
          prop: 'householdType',
          span: 12,
          rules: [
            {
              required: true,
              message: '请选择人员类型',
              trigger: 'blur',
            },
          ],
          type: 'select',
          editDisabled: true,
          search: true,
          props: {
            label: 'dictValue',
            value: 'dictKey',
          },
          dataType: 'number',
          dicUrl: '/api/blade-system/dict/dictionary?code=household_type',
        },
        {
          label: '性别',
          prop: 'sex',
          type: 'select',
          dataType: 'number',
          dicUrl: 'api/blade-system/dict/dictionary?code=sex',
          props: { label: 'dictValue', value: 'dictKey' },
          span: 12,
          rules: [
            {
              required: true,
              message: '请选择人员性别',
              trigger: 'blur',
            },
          ],
        },

        {
          label: '联系电话',
          prop: 'linkPhone',
          display: true,
          maxlength: 11,
          span: 12,
          rules: [
            {
              required: true,
              message: '请输入联系电话',
              trigger: 'change',
            },
          ],
        },
        {
          label: '身份证',
          prop: 'idCard',
          display: true,
          maxlength: 18,
          span: 12,
        },
        {
          label: '邮箱',
          prop: 'email',
          display: true,
          span: 12,
        },
        {
          label: 'QQ',
          prop: 'qq',
          display: true,
          span: 12,
        },
        {
          label: '联系地址',
          prop: 'parentObjectTypeName',
          disabled: true,
          readonly: true,
          span: 24,
        },
        {
          label: '类型',
          prop: 'objectType',
          display: false,
          readonly: true,
          span: 24,
        },
      ],
    },
  ],
};
